<script>
export default {
  data() {
    return {
      messages: {}
    };
  },
  computed: {
    message() {
      return this.messages.default || {};
    }
  },
  methods: {
    setMessage(body, type, duration = 5000, visible = true, key = "default") {
      this.messages = {
        ...this.messages,
        [key]: { body, type, duration, visible }
      };
    },
    deleteMessage(key = "default") {
      delete this.messages[key];
    },
    hasMessage(key = "default") {
      return !!this.messages[key];
    }
  }
};
</script>

